import { render, staticRenderFns } from "./StartupModal.vue?vue&type=template&id=6d2c78e0"
import script from "./StartupModal.ts?vue&type=script&lang=ts&external"
export * from "./StartupModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports